import React, { useState } from 'react';
import { Input, Button, Divider, Form } from 'antd';
import { toast } from 'react-toastify';
import UserService from '@services/userService';

interface StudentNotesFormProps {
  user: User;
  onSubmit: () => void;
}

interface StudentNotesFormValues {
  documents?: UserNotesCreateAdminForStudent[];
}

const StudentNotesForm: React.FC<StudentNotesFormProps> = ({ user, onSubmit }) => {
  const [documents, setDocuments] = useState<UserNotesCreateAdminForStudent[]>([]);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [form] = Form.useForm<StudentNotesFormValues>();

  const handleSubmit = (values: StudentNotesFormValues) => {
    const normalizedDocuments = values.documents ?? [];

    setUpdateLoading(true);

    UserService.addNotesCreateAdminForStudent(user.id, normalizedDocuments)
      .then(() => {
        setUpdateLoading(false);
        toast.success('Notes added successfully!');
        onSubmit();
      })
      .catch(() => {
        toast.error('Add failed!');
        setUpdateLoading(false);
      });
  };

  const handleAddNotes = () => {
    setDocuments((prev) => [
      ...prev,
      {
        id: -1,
        description: '',
      },
    ]);
  };

  const handleRemoveNote = (index: number) => {
    setDocuments((prev) => prev.filter((_, itemIndex) => itemIndex !== index));
  };

  return (
    <Form form={form} onFinish={handleSubmit}>
      {documents.map((document, index) => (
        <React.Fragment key={index}>
          <Form.Item
            hidden
            name={['documents', index, 'id']}
            initialValue={document.id}
            preserve={false}
          >
            <Input hidden />
          </Form.Item>
          <Form.Item
            name={['documents', index, 'description']}
            label="Description"
            rules={[
              {
                required: true,
                message: 'This field is required!',
              },
            ]}
            initialValue={document.description}
            preserve={false}
          >
            <Input.TextArea rows={2} />
          </Form.Item>
          <Button danger onClick={() => handleRemoveNote(index)}>
            Delete notes
          </Button>
          <Divider />
        </React.Fragment>
      ))}
      <Button type="primary" ghost onClick={handleAddNotes}>
        Add new notes
      </Button>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={updateLoading}>
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default StudentNotesForm;
